import validate from "/home/runner/work/pos-admin/pos-admin/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/pos-admin/pos-admin/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/runner/work/pos-admin/pos-admin/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "help-index-redirect": () => import("/home/runner/work/pos-admin/pos-admin/middleware/help-index-redirect.ts")
}